import React, { Component } from "react";
import { connect } from "react-redux";
import data from "../json/data.json";
import { StoragesSystem } from "../../../@main-module/actions-manager/actions-data";
import { withRouter } from "../../../@hoc/with-router";
import { InputBox } from "../../../@component/form/input-box/input-box";
import { ButtonActionsGlobal } from "../../../@component/form/buttons/buttons-actions-global";
import { ButtonRender } from "../../../@component/form/buttons/buttons-render";
import QrCode from "../../../@nodes/qr-code";

const PageDefaultProps = {
  StoragesSystem: {
    catalog: [],
  },
};

class SharePage extends Component {
  static defaultProps = PageDefaultProps;
  constructor(props) {
    super(props);
    this.state = {
      tamu: "",
    };
  }
  timeOut = null;

  componentDidUpdate = (prevProps) => {};

  jsEncodeURi = (str = "") => {
    const arr = str.split(" ");
    return arr.join("-");
  };

  share = () => {
    const message = `
Kepada Yth.
Bapak/Ibu/Saudara/i

*${this.state.tamu}*

---

Assalamu’alaikum Wr. Wb.

*Bismillahirrahmanirrahim*

Dengan memohon rahmat dan ridha Allah SWT, kami bermaksud mengundang Bapak/Ibu/Saudara/i untuk menghadiri acara *Walimatul Khitan* putra kami:

*${data.child.fullname}*

Insya Allah acara akan dilaksanakan sebagai ungkapan syukur atas terlaksananya ibadah khitan putra kami.

Berikut link untuk info lengkap undangan kami:

https://${window.location.host}/?tamu=${this.jsEncodeURi(this.state.tamu)}

*(Salin link dan buka di browser apabila link tidak dapat dibuka)*

Merupakan suatu kehormatan dan kebahagiaan bagi kami apabila Bapak/Ibu/Saudara/i berkenan hadir serta memberikan doa dan restu kepada putra kami.

*Mohon maaf apabila undangan ini kami sampaikan melalui pesan ini.*

Atas perhatian, kehadiran, dan doa restunya kami ucapkan terima kasih.

*Wassalamu’alaikum Wr. Wb.*

Hormat kami,

*Keluarga Besar ${data.man.fullname} & ${data.women.fullname}*
`;
    return message;
  };

  shareWA = () => {
    const el = document.createElement("a");
    el.setAttribute("href", `whatsapp://send?text=${`${encodeURIComponent(this.share())}`}`);
    el.setAttribute("target", "_blank");
    el.click();
  };

  shareFacebook = () => {
    const el = document.createElement("a");
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`https://${window.location.host}/?tamu=${this.jsEncodeURi(this.state.tamu)}`)}`;
    el.setAttribute("href", facebookShareUrl);
    el.setAttribute("target", "_blank");
    el.click();
    // const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.share()}`;
    // window.open(facebookShareUrl, '_blank', 'width=600,height=400');
  };

  shareAll = () => {
    if (this.state.tamu.length < 1) {
      alert("Maaf Nama tamu wajib di isi");
      return;
    }
    if (navigator.share) {
      navigator
        .share({
          title: `${data.women.nickname} 💞 ${data.man.nickname} Wedding`,
          text: this.share(),
          // url: `https://${window.location.host}/?tamu=${this.jsEncodeURi(this.state.tamu)}`,
        })
        .then(() => console.log("Content shared successfully"))
        .catch((error) => console.error("Error sharing content:", error));
    } else {
      alert("Sharing is not supported in this browser.");
    }
  };

  shareAllCopy = () => {
    console.log("this.state.tamu", this.state.tamu, this.state.tamu.length);

    if (this.state.tamu.length < 1) {
      alert("Maaf Nama tamu wajib di isi");
      return;
    }
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(this.share())
        .then(() => alert("Undangan Sukses Di Copy, silahkan paste di medsos teman anda"))
        .catch((error) => console.error("Error sharing content:", error));
    } else {
      alert("Copy Paste Tidak Support");
    }
  };

  onChange = ({ value }) => {
    this.setState({ tamu: value });
  };

  render() {
    return (
      <section className="share_page ">
        <div className="share_inside">
          <InputBox title={"Masukan Nama"} onChange={this.onChange} />
          <ButtonActionsGlobal onClick={this.shareWA} render={() => <ButtonRender>Share To Whatsapp</ButtonRender>} />
          <ButtonActionsGlobal onClick={this.shareFacebook} render={() => <ButtonRender>Share to Facebook</ButtonRender>} />
          <ButtonActionsGlobal onClick={this.shareAll} render={() => <ButtonRender>Share to Phone</ButtonRender>} />
          <br />
          <br />
          <div>Jika Aplikasi yang anda inginkan tidak muncul di list share, bisa pake tombol copy di bawah ini, klik copy, dan paste di chat atau instagram teman / keluarga anda</div>
          <br />
          <ButtonActionsGlobal onClick={this.shareAllCopy} render={() => <ButtonRender>Share by Copy Paste</ButtonRender>} />
          <QrCode textTitle="Walimatul Khitan" theme="sunatan" user={this.state.tamu} data={data} />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  StoragesSystem: state.StoragesSystem,
});
const mapDispatchToProps = (dispatch) => ({
  setStorage: (data = { data: null, type: "yourkey" }) => dispatch(new StoragesSystem().setStorage(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  withRouter(SharePage, {
    isRestriected: true,
  }),
);
